/**
 * Authenticated Layout
 * Wraps all authenticated pages and includes global components like the GracePeriodBanner.
 */
import React, { useState, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import GracePeriodBanner from './admin/GracePeriodBanner';
import TokenBudgetBanner from './banners/TokenBudgetBanner';

const AuthenticatedLayout = ({ children }) => {
  const { user } = useAuth();
  const [graceBannerVisible, setGraceBannerVisible] = useState(false);
  const [tokenBannerVisible, setTokenBannerVisible] = useState(false);

  const handleGraceBannerVisibility = useCallback((visible) => {
    setGraceBannerVisible(visible);
  }, []);

  const handleTokenBannerVisibility = useCallback((visible) => {
    setTokenBannerVisible(visible);
  }, []);

  // Calculate total banner height (each banner is ~52px when visible)
  const totalBannerHeight = (graceBannerVisible ? 52 : 0) + (tokenBannerVisible ? 44 : 0);

  return (
    <>
      {/* Global Grace Period Banner */}
      {user?.organization_id && (
        <GracePeriodBanner 
          organizationId={user.organization_id}
          userRole={user.role}
          onVisibilityChange={handleGraceBannerVisibility}
        />
      )}
      
      {/* Token Budget Warning Banner (for owners only) */}
      {user?.organization_id && (
        <div style={{ paddingTop: graceBannerVisible ? '52px' : '0' }}>
          <TokenBudgetBanner 
            onVisibilityChange={handleTokenBannerVisibility}
          />
        </div>
      )}
      
      {/* Page Content - add top padding when banners are visible */}
      <div style={{ paddingTop: `${totalBannerHeight}px` }}>
        {children}
      </div>
    </>
  );
};

export default AuthenticatedLayout;
